import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatModalActionTypes {
  Open = 'chatModal/open',
  Close = 'chatModal/close',
}

export interface IOpenChatModalPayload {
  gaLabel: string;
  offerId: number;
  defaultMessage?: string;
}

export type TChatModalOpen = ITypedReduxAction<EChatModalActionTypes.Open, IOpenChatModalPayload>;
export type TChatModalClose = ITypedReduxAction<EChatModalActionTypes.Close>;

export type TChatModalActions = TChatModalOpen | TChatModalClose;
